import { get } from 'app/utils/axios/kheti'
import { Insurance, InsuranceTypeCounts } from "../models/inusrance";

interface Response {
  count: number;
  next: string | null;
  previous: string | null;
  results: Insurance[];
  insurance_type_counts: InsuranceTypeCounts;
}

const fetchFarmerInsurance = async (farmerId: string) => {
  try {
    const url = `/farmer-360/v1/farmer/${farmerId}/insurance`;
    return await get<Response>(url);
  } catch (e) {
    return null;
  }
};

export default fetchFarmerInsurance;
